import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  CircularProgress,
  Button,
  Modal,
} from "@mui/material";
import "../assets/css/EvalouForm.css";
import "../assets/css/icon.css";
import React, { useEffect, useState } from "react";
import {
  knowledgeByTeam,
  sectionsFirst,
  sectionsSecond,
} from "../utils/sectionValuo";
import { renderTable } from "./TableForm";
import ModalConferma from "./Generics/ModalConferma";
import { service } from "../model";
import { useSelector } from "react-redux";
import ModalSuccess from "./Generics/ModalSuccess";
import { useNavigate } from "react-router-dom";
import ModalError from "./Generics/ModalError";
import "../../src/assets/css/BoxButton.css";

// COMPONENTE VALUTAZIONE
const EValouForm = ({
  user,
  eValuo,
  setEValuo,
  errors,
  id,
  loadAppData,
  setErrors,
}) => {
  const navigate = useNavigate();
  const reduxObject = useSelector((state) => state.user?.redux_object);
  const token = reduxObject.accessToken;
  const isProfessionista = user.role === "collaborator";
  const isPartner = user.role === "partner";

  const teamsObjectSection = JSON.parse(eValuo?.collaborator?.teams || "{}");
  const team = Object.keys(teamsObjectSection)[0] || "";

  // team
  const teamsObject = JSON.parse(user.teams);

  const phaseEvaluo = Number(eValuo?.phase);

  const [openDeleteEvaluo, setOpenDeleteEvaluo] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [apiErrorModal, setApiErrorModal] = useState(false);

  const [textValue, setTextValue] = useState("");

  const handleCloseModalDelete = () => setOpenDeleteEvaluo(false);

  const formatKey = (label = "") =>
    label
      .toString()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/[^\w_]/g, "")
      .replace(/^./, (char) => char.toLowerCase());

  const handleChangeEValuo = (label, value) => {
    const type = user.role;
    const fieldName = formatKey(label);

    setErrors((prev) => prev.filter((err) => err !== fieldName));

    setEValuo((prev) => {
      const updatedData = {
        ...(prev[`data_${type}`] || {}),
        [fieldName]: value,
      };

      const scoreField =
        type === "collaborator"
          ? "score_valutation_collaborator"
          : "score_valutation_partner";

      updatedData[scoreField] = calculateScore(
        updatedData,
        [...sectionsFirst, ...sectionsSecond],
        type
      );

      return {
        ...prev,
        [`data_${type}`]: updatedData,
      };
    });
  };

  // calcola punteggio valutazione partner || collaborator
  const calculateScore = (data, sections, role) => {
    if (!sections || sections.length === 0) return "0/0";

    let totalScore = 0;
    let maxScore = 0;

    sections.forEach((section) => {
      (section.rows || []).forEach((row) => {
        const key = `${formatKey(row)}_${role}`;
        const value = data?.[key];

        // se è N.A. non calcola il +5
        if (value === "N.A.") {
          return;
        }

        const numericValue = parseInt(value, 10);
        if (!isNaN(numericValue)) {
          totalScore += numericValue;
          maxScore += 5;
        }
      });
    });

    return `${totalScore}/${maxScore}`;
  };

  const getSectionsFirst = (teamsObject) => {
    const knowledgeRows = Object.keys(teamsObject)
      .filter((team) => knowledgeByTeam[team])
      .flatMap((team) => knowledgeByTeam[team]);

    const sections = [
      {
        title: "Skills",
        rows: [
          "Predisposizione pareri legali",
          "Predisposizione contratti",
          "Predisposizione policy e procedure",
          "Ricerche",
          "Scrittura e-mail",
          "Formattazione",
          "Lingua inglese",
        ],
      },
    ];

    if (knowledgeRows.length > 0) {
      sections.push({
        title: "Knowledge",
        rows: knowledgeRows,
      });
    }

    sections.push({
      title: "Business development",
      rows: [
        "Origination",
        "Networking",
        "Iniziative di knowledge",
        "Interesse per novità normative",
      ],
    });

    return sections;
  };

  const sectionsFirstDynamic = getSectionsFirst(teamsObjectSection);

  const collaboratorScore = calculateScore(
    eValuo.data_collaborator,
    [...sectionsFirstDynamic, ...sectionsSecond],
    "collaborator"
  );

  const partnerScore = calculateScore(
    eValuo.data_partner,
    [...sectionsFirstDynamic, ...sectionsSecond],
    "partner"
  );

  const deleteEvaluo = async () => {
    try {
      await service.deleteEvaluation(token, id);
      loadAppData();

      setOpenDeleteEvaluo(false);
      setOpenSuccessModal(true);
    } catch (error) {
      console.error("Errore", error);
      setOpenDeleteEvaluo(false);
      setApiErrorModal(true);
    }
  };

  const closeSuccessAndRedirect = () => {
    setOpenSuccessModal(false);
    navigate("/");
  };

  if (!eValuo || Object.keys(eValuo).length === 0) {
    return;
  }

  const renderTextarea = (field, placeholder) => {
    const hasError = errors?.includes(field);

    const role = user.role;
    const dataCollaborator = eValuo?.data_collaborator || {};
    const dataPartner = eValuo?.data_partner || {};

    const value =
      phaseEvaluo >= 2
        ? dataCollaborator[field] || dataPartner[field] || ""
        : eValuo?.[`data_${role}`]?.[field] || "";

    const disabled = phaseEvaluo > 0;

    const bgColor = hasError
      ? "#ffcccc"
      : phaseEvaluo > 0
      ? "#fff"
      : "#fae63436";

    if (role === "collaborator" && phaseEvaluo === 0) {
      return (
        <div style={{ position: "relative" }}>
          <textarea
            disabled={disabled}
            style={{ backgroundColor: bgColor, paddingBottom: "24px" }}
            placeholder={placeholder}
            className="textareaStyle"
            value={value}
            maxLength={2000}
            onChange={(e) => handleChangeEValuo(field, e.target.value)}
          />
          <span
            style={{
              position: "absolute",
              bottom: "6px",
              right: "10px",
              fontSize: "12px",
              color: "#7a7a7a",
              pointerEvents: "none",
            }}
          >
            {value.length}/2000
          </span>
        </div>
      );
    }

    if (phaseEvaluo <= 1) {
      return (
        <textarea
          disabled
          style={{ backgroundColor: "#fff" }}
          placeholder={placeholder}
          className="textareaStyle"
          value={value}
        />
      );
    }

    return (
      <Typography sx={{ padding: "12px 16px", color: "#1b2838" }}>
        {value || placeholder}
      </Typography>
    );
  };

  return (
    <>
      <Grid
        item
        xs={11}
        md={8}
        style={{ display: "flex", paddingBottom: "20px" }}
      >
        <Grid item xs={12}>
          <Grid item xs={12} sx={{ display: "flex" }}>
            <Grid item xs={6}>
              <Typography
                className="color-blue-dark"
                sx={{
                  fontSize: { xs: "18px", sm: "20px", md: "22px" },
                  fontWeight: 600,
                  marginBottom: "20px",
                }}
              >
                Scheda di valutazione professionale
              </Typography>
              <Typography sx={{ fontSize: { xs: "16px", md: "16px" } }}>
                Professionista: {eValuo?.collaborator?.name || ""}
              </Typography>
              <Typography sx={{ fontSize: { xs: "16px", md: "16px" } }}>
                Team: {team || ""}
              </Typography>
              <Typography sx={{ fontSize: { xs: "16px", md: "16px" } }}>
                Partner: {eValuo?.partner?.name || ""}
              </Typography>
              <Typography sx={{ fontSize: { xs: "16px", md: "16px" } }}>
                Anno valutato: {eValuo?.year || ""}
              </Typography>
              <Typography sx={{ fontSize: { xs: "16px", md: "16px" } }}>
                Data valutazione:{" "}
                {eValuo?.created_at
                  ? new Date(eValuo.created_at).toLocaleDateString("it-IT", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    })
                  : "-"}
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "start",
              }}
            >
              {" "}
              {isPartner && phaseEvaluo === 0 && (
                <Button
                  variant="contained"
                  className="button-bg-purple"
                  onClick={() => setOpenDeleteEvaluo(true)}
                >
                  <Typography
                    className="color-light"
                    sx={{
                      textTransform: "initial",
                      fontSize: { xs: "16px", sm: "18px" },
                      fontWeight: 500,
                    }}
                  >
                    Interrompi
                  </Typography>
                </Button>
              )}
            </Grid>
          </Grid>

          {isPartner && phaseEvaluo <= 2 && (
            <Grid
              item
              xs={12}
              sx={{
                backgroundColor: "#fae63436",
                padding: "15px",
                color: "#1b2838",
                height: "fit-content",
                marginBottom: "30px",
                marginTop: "30px",
              }}
            >
              <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={0.44}>
                  <div
                    className="icon-info"
                    style={{
                      marginTop: "2px",
                    }}
                  />
                </Grid>

                <Grid item xs={11}>
                  {phaseEvaluo === 0 ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: 600,

                          color: "#1b2838",
                        }}
                      >
                        Processo di valutazione in corso
                      </Typography>
                      <Typography>
                        Attendi che il professionista inserisca la propria
                        autovalutazione. Riceverai un’email quando avrà
                        terminato.
                      </Typography>
                    </>
                  ) : phaseEvaluo === 1 ? (
                    <>
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: 600,

                          color: "#1b2838",
                        }}
                      >
                        Processo di valutazione in corso
                      </Typography>
                      <Typography>
                        Il professionista ha inserito la sua autovalutazione.
                        Compila i campi richiesti per valutare il
                        professionista.
                      </Typography>
                    </>
                  ) : phaseEvaluo === 2 ? (
                    <>
                      {" "}
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: 600,

                          color: "#1b2838",
                        }}
                      >
                        Processo di valutazione in corso
                      </Typography>
                      <Typography>
                        Hai inserito la valutazione del professionista.{" "}
                        <a
                          className="color-purple"
                          sx={{ textTransform: "underline" }}
                          href="https://calendar.google.com/calendar/u/0/r/eventedit?text=1+to+1+%E2%80%93+Revisione+valutazione&details=Meeting+1+to+1+per+discutere+dell%27esito+della+valutazione+professionale+e+concordare+gli+obiettivi+per+il+prossimo+anno+in+LEXIA."
                          target="_blank"
                        >
                          Fissa a stretto giro una riunione
                        </a>{" "}
                        con il professionista per discutere il risultato e
                        concordare gli obiettivi per il prossimo anno (da
                        inserire nell’apposito campo in basso della
                        valutazione). Solo dopo la riunione potrai concludere il
                        processo di valutazione cliccando su “Completa”.
                      </Typography>
                    </>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* Leggenda */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              backgroundColor: "#f2f2f2",
              padding: "12px 16px",
              marginTop: "20px",
            }}
          >
            <Typography
              className="color-blue-dark"
              sx={{
                fontWeight: 600,
                marginBottom: "6px",
                fontSize: "16px",
              }}
            >
              Scala di valutazione
            </Typography>
            <Typography
              className="color-blue-dark"
              sx={{ fontSize: "16px", lineHeight: 1.5 }}
            >
              <strong>NA:</strong> Non applicabile e non conteggiato <br />
              <strong>1:</strong> Insufficiente <br />
              <strong>2:</strong> Sufficiente <br />
              <strong>3:</strong> Discreto <br />
              <strong>4:</strong> Buono <br />
              <strong>5:</strong> Ottimo
            </Typography>
          </Grid>

          {renderTable(
            errors,
            user,
            sectionsFirstDynamic,
            "Capacità professionali",
            "Autovalutazione Professionista",
            "Valutazione Partner",
            handleChangeEValuo,
            eValuo,
            formatKey
          )}

          {renderTable(
            errors,
            user,
            sectionsSecond,
            "Capacità comportamentali",
            "Autovalutazione Risorsa",
            "Valutazione Partner",
            handleChangeEValuo,
            eValuo,
            formatKey,
            true
          )}

          {/* Calcolo punteggio */}
          <TableContainer
            component={Paper}
            sx={{
              marginTop: "50px",
              overflowX: "auto",
              borderRadius: 0,
              boxShadow: "none",
            }}
          >
            <Table
              size="small"
              sx={{
                tableLayout: "fixed",
                width: "100%",
                minWidth: "600px",
              }}
            >
              <TableHead className="bg-blue-dark">
                <TableRow>
                  <TableCell
                    sx={{
                      padding: "16px 16px",
                      width: "40%",
                    }}
                  >
                    <Typography className="color-light">
                      Calcolo automatico
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "16px 16px",
                      width: "30%",
                      textAlign: "center",
                    }}
                  >
                    <Typography className="color-light">
                      Autovalutazione Professionista
                    </Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "16px 16px",
                      width: "30%",
                      textAlign: "center",
                    }}
                  >
                    <Typography className="color-light">
                      Valutazione Partner
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell
                    sx={{
                      padding: "10px 16px",
                    }}
                  >
                    <Typography className="color-blue-dark">
                      Punteggio totale
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Typography
                      className="color-blue-dark"
                      sx={{ letterSpacing: "2px" }}
                    >
                      {phaseEvaluo >= 2
                        ? collaboratorScore || "-"
                        : user.role === "collaborator"
                        ? collaboratorScore || "-"
                        : "-"}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Typography
                      className="color-blue-dark"
                      sx={{ letterSpacing: "2px" }}
                    >
                      {phaseEvaluo === 0
                        ? "-"
                        : phaseEvaluo >= 2
                        ? partnerScore || "-"
                        : user.role === "partner"
                        ? partnerScore || "-"
                        : "-"}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* Ulteriori aspetti */}
          <Grid item xs={12} sx={{ marginTop: "50px", marginBottom: "50px" }}>
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 0,
                boxShadow: "none",
                overflow: "hidden",
              }}
            >
              <Table size="small" sx={{ width: "100%", tableLayout: "fixed" }}>
                <TableHead className="bg-blue-dark">
                  <TableRow>
                    <TableCell>
                      <Typography className="color-light">
                        Ulteriori aspetti (compilazione a cura del solo
                        Professionista)
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {/* Punti di forza */}
                  <TableRow>
                    <TableCell
                      sx={{ backgroundColor: "#a2bdcb", padding: "8px 16px" }}
                    >
                      <Typography
                        className="color-blue-dark"
                        sx={{ fontWeight: 600, marginBottom: "4px" }}
                      >
                        Punti di forza
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ padding: 0 }}>
                      {renderTextarea(
                        "punti_di_forza",
                        "Descrivere, anche tramite bullet point, i punti di forza che il professionista ritiene contraddistinguano il proprio apporto professionale allo studio."
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Punti di debolezza */}
                  <TableRow>
                    <TableCell
                      sx={{ backgroundColor: "#a2bdcb", padding: "8px 16px" }}
                    >
                      <Typography
                        className="color-blue-dark"
                        sx={{ fontWeight: 600, marginBottom: "4px" }}
                      >
                        Punti di debolezza
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ padding: 0 }}>
                      {renderTextarea(
                        "punti_di_debolezza",
                        "Descrivere, anche tramite bullet point, i punti di debolezza su cui il professionista ritiene di dover lavorare per migliorare il proprio apporto professionale allo studio."
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Obiettivi e aree di miglioramento */}
                  <TableRow>
                    <TableCell
                      sx={{ backgroundColor: "#a2bdcb", padding: "8px 16px" }}
                    >
                      <Typography
                        className="color-blue-dark"
                        sx={{ fontWeight: 600, marginBottom: "4px" }}
                      >
                        Obiettivi e aree di miglioramento
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ padding: 0 }}>
                      {renderTextarea(
                        "obiettivi_aree_miglioramento",
                        "Descrivere, anche tramite bullet point, gli obiettivi professionali e le aree di miglioramento a cui il professionista intende dedicarsi nel corso del nuovo anno."
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Obiettivi condivisi per il nuovo anno */}
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: "#1b2838",
                        padding: "8px 16px",
                      }}
                    >
                      <Typography sx={{ color: "#fff", fontWeight: 600 }}>
                        Obiettivi condivisi per il nuovo anno{" "}
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell sx={{ padding: 0 }}>
                      {isPartner ? (
                        phaseEvaluo === 3 ? (
                          <div style={{ width: "100%", display: "block" }}>
                            <Typography
                              sx={{
                                display: "block",
                                width: "100%",
                                boxSizing: "border-box",
                                padding: "12px 16px",
                                color: "#1b2838",
                                whiteSpace: "pre-wrap",
                                overflowWrap: "break-word",
                              }}
                            >
                              {eValuo?.comment_call_review ||
                                "Inserisci eventuali commenti per la review della valutazione"}
                            </Typography>
                          </div>
                        ) : (
                          <div style={{ position: "relative", width: "100%" }}>
                            <textarea
                              value={
                                eValuo?.data_partner?.obiettivi_condivisi || ""
                              }
                              onChange={(e) =>
                                handleChangeEValuo(
                                  "obiettivi_condivisi",
                                  e.target.value
                                )
                              }
                              maxLength={5000}
                              style={{
                                backgroundColor: errors?.includes(
                                  "obiettivi_condivisi"
                                )
                                  ? "#ffcccc"
                                  : phaseEvaluo === 2
                                  ? "#fae63436"
                                  : "#fff",
                                width: "100%",
                                paddingBottom: "24px",
                                boxSizing: "border-box",
                              }}
                              disabled={phaseEvaluo !== 2}
                              placeholder={
                                phaseEvaluo === 2
                                  ? "Inserisci"
                                  : "Questa sezione sarà abilitata al Partner non appena anche lei/lui completerà la valutazione. La compilazione sarà effettuata di concerto con il Professionista durante la call di review della scheda di valutazione."
                              }
                              className="textareaStyle"
                            />
                            {phaseEvaluo === 2 && (
                              <span
                                style={{
                                  position: "absolute",
                                  bottom: "6px",
                                  right: "10px",
                                  fontSize: "12px",
                                  color: "#7a7a7a",
                                  pointerEvents: "none",
                                }}
                              >
                                {
                                  (
                                    eValuo?.data_partner?.obiettivi_condivisi ||
                                    ""
                                  ).length
                                }
                                /5000
                              </span>
                            )}
                          </div>
                        )
                      ) : (
                        <Typography
                          sx={{
                            padding: "12px 16px",
                            color: phaseEvaluo === 3 ? "#1b2838" : "#7a8a9a",
                            fontStyle: "italic",
                          }}
                        >
                          {phaseEvaluo === 3
                            ? eValuo?.comment_call_review
                            : "Questa sezione sarà abilitata al Partner non appena anche lei/lui completerà la valutazione. La compilazione sarà effettuata di concerto con il Professionista durante la call di review della scheda di valutazione."}
                        </Typography>
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openDeleteEvaluo} onClose={handleCloseModalDelete}>
        <div>
          <ModalConferma
            title=" Interrompi valutazione"
            descriptionOne="Sei ancora in tempo per interrompere il processo perché il professionista non ha completato la propria autovalutazione. L’interruzione è irreversibile."
            descriptionTwo="Sei sicuro di voler procedere?"
            copyButton="Sì, interrompi"
            confirm={deleteEvaluo}
            onClose={handleCloseModalDelete}
          />
        </div>
      </Modal>

      <Modal open={openSuccessModal} onClose={closeSuccessAndRedirect}>
        <div>
          <ModalSuccess
            title="Processo di valutazione interrotto"
            descriptionOne="Il professionista non può più accedere alla valutazione."
            descriptionTwo=""
            copyButton="Chiudi"
            confirm={closeSuccessAndRedirect}
            onClose={closeSuccessAndRedirect}
          />
        </div>
      </Modal>

      <Modal open={apiErrorModal} onClose={() => setApiErrorModal(false)}>
        <div>
          <ModalError
            title="Ops, qualcosa è andato storto"
            descriptionOne="Si è verificato un errore tecnico momentaneo."
            descriptionTwo="Ti invitiamo a riprovare tra qualche minuto. Grazie."
            copyButton="Chiudi"
            confirm={() => setApiErrorModal(false)}
            onClose={() => setApiErrorModal(false)}
          />
        </div>
      </Modal>
    </>
  );
};

export default EValouForm;
